<template>
  <div v-if="bidders.length > 0">
    <div v-for="bidder in bidders" :key="bidder.id" class="row">
      <div class="col-lg-6 d-flex">
        <div
          class="card border-start border-start-width-2 border-start-secondary p-2"
        >
          <div class="row">
            <div class="col-6"><h6>Dados do Proponente</h6></div>
            <div v-if="canEditProject" class="col-6 text-end">
              <span
                role="button"
                class="badge bg-danger me-2"
                title="Remover Proponente"
                @click="$emit('deleteBidderProject', bidder.id)"
              >
                Remover
              </span>
              <span
                role="button"
                class="badge bg-primary me-2"
                title="Alterar Proponente"
                @click="$emit('editBidderProject', bidder.id)"
              >
                Alterar
              </span>
              <span
                role="button"
                class="badge bg-warning"
                title="Editar Dados do Proponente"
                @click="$emit('editBidderPartner', bidder.bidderPartnerId)"
              >
                Editar
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p><strong>Nome:</strong> {{ bidder.bidderPartnerName }}</p>
            </div>
            <div class="col-sm-12">
              <p><strong>CNPJ:</strong> {{ bidder.bidderPartnerCnpj }}</p>
            </div>
            <div class="col-sm-12">
              <p>
                <strong>Endereço:</strong> {{ bidder.bidderPartnerAddress }},
                {{ bidder.bidderPartnerNumber }} -
                {{ bidder.bidderPartnerDistrict }}
              </p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Estado/UF:</strong> {{ bidder.bidderPartnerCity }} -
                {{ bidder.bidderPartnerUf }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>CEP:</strong> {{ bidder.bidderPartnerCep }}</p>
            </div>
            <div v-if="bidder.bidderPartnerComplement" class="col-sm-12">
              <p>
                <strong>Complemento:</strong>
                {{ bidder.bidderPartnerComplement }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>E-mail:</strong> {{ bidder.bidderPartnerEmail }}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Telefone:</strong> {{ bidder.bidderPartnerPhone }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="card border-start border-start-width-2 border-start-secondary p-2"
        >
          <div class="row">
            <div class="col-6"><h6>Dados do Responsável</h6></div>
            <div v-if="canEditProject" class="col-6 text-end">
              <span
                role="button"
                class="badge bg-warning"
                title="Editar Dados do Responsável"
                @click="
                  $emit('editResponsible', {
                    bidderPartnerId: bidder.bidderPartnerId,
                    responsibleId: bidder.responsibleId,
                  })
                "
              >
                Editar
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p><strong>Nome:</strong> {{ bidder.responsibleName }}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>CPF:</strong> {{ bidder.responsibleCpf }}</p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Identidade:</strong> {{ bidder.responsibleIdentity }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>Função:</strong> {{ bidder.responsibleFunction }}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Cargo:</strong> {{ bidder.responsibleRole }}</p>
            </div>
            <div class="col-sm-12">
              <p>
                <strong>Endereço:</strong> {{ bidder.responsibleAddress }},
                {{ bidder.responsibleNumber }} -
                {{ bidder.responsibleDistrict }}
              </p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Cidade/UF:</strong> {{ bidder.responsibleCity }} -
                {{ bidder.responsibleUf }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>CEP:</strong> {{ bidder.responsibleCep }}</p>
            </div>
            <div v-if="bidder.responsibleComplement" class="col-sm-12">
              <p>
                <strong>Complemento:</strong>
                {{ bidder.responsibleComplement }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>E-mail:</strong> {{ bidder.responsibleEmail }}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Telefone:</strong> {{ bidder.responsiblePhone }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <p class="text-center">
      Este sumário executivo não possui nenhum proponente vinculado
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListBiddersProject',

  props: {
    bidders: {
      type: Array,
      required: true,
    },
  },

  emits: [
    'deleteBidderProject',
    'editBidderProject',
    'editBidderPartner',
    'editResponsible',
  ],

  computed: {
    ...mapGetters(['canEditProject']),
  },
}
</script>
